const calculateDefaultRowValues = ({
  timesheetDimensions = {},
  row = {},
  tasksData = [],
  departmentOptions = [],
  locationOptions = [],
}) => {
  let pClientId = null;
  let pProjectId = null;
  let pTaskId = null;
  let pItemId = null;
  let pTimeTypeId = null;
  let pDepartment = null;
  let pLocation = null;
  let pBillable = false;
  let taskObj = null;
  let pDepartmentObj = null;
  let pLocationObj = null;
  if (row.entries && row.entries.length > 0) {
    const firstRowEntry = row.entries[0];
    if (timesheetDimensions.showCustom) {
      pClientId = firstRowEntry.confirmedClientId;
    }
    if (timesheetDimensions.showProject) {
      pProjectId = firstRowEntry.confirmedProjectId;
    }
    if (timesheetDimensions.showTask) {
      pTaskId = firstRowEntry.confirmedTaskId;
      taskObj = tasksData.find((t) => t.id === pTaskId);
    }
    if (timesheetDimensions.showItem) {
      pItemId = firstRowEntry.confirmedItemId;
    }
    if (timesheetDimensions.showTimeType) {
      pTimeTypeId = firstRowEntry.timeTypeId;
    }
    if (timesheetDimensions.showDepartmentLocation) {
      pDepartmentObj = departmentOptions?.find((v) => {
        return !!firstRowEntry.dimensions?.find((d) => d.dimension_value_id === v.id);
      });
      pDepartment = pDepartmentObj?.id;
      pLocationObj = locationOptions?.find((v) => {
        return !!firstRowEntry.dimensions?.find((d) => d.dimension_value_id === v.id);
      });
      pLocation = pLocationObj?.id;
    }
    pBillable = firstRowEntry.billable;
  } else if (row.dimensionValues) {
    if (timesheetDimensions.showCustom) {
      pClientId = row.dimensionValues?.clientId;
    }
    if (timesheetDimensions.showProject) {
      pProjectId = row.dimensionValues?.projectId;
    }
    if (timesheetDimensions.showTask) {
      pTaskId = row.dimensionValues?.taskId;
    }
    if (timesheetDimensions.showItem) {
      pItemId = row.dimensionValues?.itemId;
    }
    if (timesheetDimensions.showTimeType) {
      pTimeTypeId = row.dimensionValues?.timeTypeId;
    }
    if (timesheetDimensions.showDepartmentLocation) {
      pDepartment = row.dimensionValues?.departmentId;
      pLocation = row.dimensionValues?.locationId;
    }
    if (timesheetDimensions.showBillable) {
      pBillable = row.dimensionValues?.billable;
    }
  } else {
    pBillable = taskObj?.billable;
  }
  return {
    pBillable,
    pClientId,
    pDepartment,
    pDepartmentObj,
    pItemId,
    pLocation,
    pLocationObj,
    pProjectId,
    pTaskId,
    pTimeTypeId,
    taskObj,
  };
};

export { calculateDefaultRowValues };
